import colors from "@/data/color/color.data";

const state = {
  colors: colors,
  showDialog: false,
  togglePano: false,
  initializedSpin: false,
  initializedPano: false,
  sliderIndex: 0,
  currentAngle: 0,
  currentColorIndex: 0,
  slider: {
    loop: false,
    simulateTouch: false,
    followFinger: false,
    allowTouchMove: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    }
  }
};

const getters = {
  carSlider: (state: {}) => {
    return state;
  }
};

const mutations = {};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
